<template>
  <div class="sect-wrapper" :style="{ height, width }">
    <div v-if="title" class="sect-title">
      <div class="title">
        <div class="icon"></div>
        <p>{{ title }}</p>
      </div>
      <div>
        <slot name="title-extra"></slot>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "AppCard",
  components: {},
  props: ["height", "title", "width"],
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.sect-wrapper {
  position: relative;
  width: 100%;
  background: #fff;
  .sect-title {
    padding: 0 10px;
    height: 40px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title {
      display: flex;
      align-items: center;
      font-size: 20px;
      color: #303133;

      .icon {
        width: 2px;
        height: 20px;
        margin-right: 10px;
        background: #fff;
      }
    }
  }
}
</style>
